/* eslint-disable */
import axios from 'axios';
import * as auth from '../components/ComponentesAutenticacao/utils';

import * as actions from './baseActions';
import store from '../reducers';
import { tamanhoMaximoArquivoUpload } from '../utils/constants';

export const exibirMensagem = (mensagem, type) => {
  const snackMessage = {
    title: 'Título da Mensagem',
    text: mensagem,
    timeout: 24000,
    type,
  };
  window.DtpSnackbar.addMessage(snackMessage);
};

export const exibirMensagensSnackbar = (listaMensagens, type) => {
  listaMensagens.forEach((mensagem) => {
    exibirMensagem(mensagem, type);
  });
};

export const trataMensagemSucesso = (mensagem) => {
  exibirMensagensSnackbar([mensagem], 'success');
};

export const trataMensagensErro = (listaMensagens) => {
  exibirMensagensSnackbar(listaMensagens, 'danger');
};

export const exibirMensagemBloqueioDesbloqueio = (mensagem, type) => {
  const snackMessage = {
    title: 'Título da Mensagem',
    text: mensagem,
    timeout: 600000,
    type,
  };
  window.DtpSnackbar.addMessage(snackMessage);
};

export const exibirMensagensSnackbarBloqueioDesbloqueio = (listaMensagens, type) => {
  listaMensagens.forEach((mensagem) => {
    exibirMensagemBloqueioDesbloqueio(mensagem, type);
  });
};

export const trataMensagemSucessoBloqueioDesbloqueio = (mensagem) => {
  exibirMensagensSnackbarBloqueioDesbloqueio([mensagem], 'success');
};

export const validateObject = listFieldValidation => (
  Object
    .keys(listFieldValidation)
    .reduce((currValidation, pn) => listFieldValidation[pn] === true && currValidation, true)
);

// Funcoes uteis para requests (tratamento de mensagens de erros, GET, POST, PUT)

const handleErrorMessages = (error, callback, mensagemErro) => {
  if (error.response) {
    const { data } = { ...error.response };
    switch (error.response.status) {
      case 400: {
        const listaMensagens = [];
        if (data.tipo === 2) break; // Mensagens de alerta
        if (data.erros && data.erros.length >= 1) {
          data.erros.forEach((erro) => {
            if (mensagemErro && erro.codigo === mensagemErro.codigo) {
              listaMensagens.push(mensagemErro.mensagem);
            } else {
              listaMensagens.push(`${erro.mensagem} ${erro.descricao}`);
            }
          });
          trataMensagensErro(listaMensagens);
        } else if (mensagemErro && data.codigo === mensagemErro.codigo) {
          trataMensagensErro([mensagemErro.mensagem]);
        } else {
          trataMensagensErro([`${data.mensagem} ${data.descricao}`]);
        }
        break;
      }
      case 401: {
        if (error.response.data.error && error.response.data.error[0] === 'expired_accessToken') {
          trataMensagensErro(['Acesso expirado. Faça o login de novo para acessar o recurso.']);
        } else {
          trataMensagensErro(['Acesso não autorizado. O usuário não possui permissão para acessar o recurso.']);
        }
        break;
      }
      case 403: {
        if (mensagemErro) {
          trataMensagensErro([mensagemErro.mensagem]);
        } else {
          trataMensagensErro(['Operação não permitida. O usuário não possui permissão para realizar a operação.']);
        }
        break;
      }
      case 404: {
        if (data.mensagem && data.descricao) {
          trataMensagensErro([`${data.mensagem} ${data.descricao}`]);
        }
        break;
      }
      case 409: {
        if (data.mensagem && data.descricao) {
          trataMensagensErro([`${data.mensagem} ${data.descricao}`]);
        }
        break;
      }
      case 500: {
        const listaMensagens = [];
        if (data.mensagem) {
          listaMensagens.push(`${data.mensagem} ${data.descricao}`);
        } else {
          listaMensagens.push('Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.');
        }
        trataMensagensErro(listaMensagens);
        break;
      }
      default:
        trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);
    }
    if (callback) {
      callback(error.response);
    }
  } else {
    trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);
    if (callback) {
      callback(error.response);
    }
  }
};

const getURLParams = (params) => {
  const urlParams = new URLSearchParams();
  if (params) {
    const keys = Object.keys(params);
    keys.forEach((key) => {
      if (Array.isArray(params[key])) {
        params[key].forEach((item) => {
          urlParams.append(key, item);
        });
      } else {
        urlParams.append(key, params[key]);
      }
    });
  }
  return urlParams;
};

const { comprevNewdooUrl } = window.comprevConfig;
const baseUrl = `${comprevNewdooUrl}/apis/comprevws`;

export const doPost = (url, body, successCallback, failCallback, config) => {
  store.dispatch(actions.showLoading(true));
  let configComAuth = {};
  let headersOpcionais = {};
  if (config) {
    headersOpcionais = config;
  }
  configComAuth = {
    headers: {
      Authorization: auth.getAuthorizationHeader(),
      ...headersOpcionais,
    },
  };
  axios.post(
    `${baseUrl}/${url}`,
    body,
    configComAuth,
  ).then((response) => {
    successCallback(response);
  }).catch((error) => {
    const erroServico = error;
    handleErrorMessages(erroServico || error, failCallback);
  }).then(() => {
    store.dispatch(actions.showLoading(false));
  });
};

export async function doPostPaginado (url, body, maxResult ,successCallback, failCallback, config) {
  store.dispatch(actions.showLoading(true));
  const instance = axios.create({
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.getAuthorizationHeader(),
    },
    data: {},
  });

  let configComAuth = {};
  let headersOpcionais = {};

  const responseFinal = { data: [] };
  const parametros = body;
  parametros.start = 1;
  parametros.maxResult = maxResult;
  let keep = true;

  if (config) {
    headersOpcionais = config;
  }
  configComAuth = {
    headers: {
      Authorization: auth.getAuthorizationHeader(),
      ...headersOpcionais,
    },
  };
  try {
      while (keep) {
        // eslint-disable-next-line no-await-in-loop
        const response = await instance.post(`${baseUrl}/${url}`, body, configComAuth);
        if (response.data.length < parametros.maxResult) {
          keep = false;
        }
        responseFinal.data = responseFinal.data.concat(response.data);
        parametros.start += parametros.maxResult;
      }
      store.dispatch(actions.showLoading(false));
      successCallback(responseFinal);
    } catch (e) {
      store.dispatch(actions.showLoading(false));
      handleErrorMessages(e, failCallback);
    }
};

export const doPostExigencias = (
  url, body, successCallback,
  failCallback, config, tamanhoArquivo,
) => {
  store.dispatch(actions.showLoading(true));
  let configComAuth = {};
  let headersOpcionais = {};
  if (config) {
    headersOpcionais = config;
  }
  configComAuth = {
    headers: {
      Authorization: auth.getAuthorizationHeader(),
      ...headersOpcionais,
    },
  };
  axios.post(
    `${baseUrl}/${url}`,
    body,
    configComAuth,
  ).then((response) => {
    successCallback(response);
  }).catch((error) => {
    const erroServico = error;

    if (url === 'documentos') {
      if (erroServico.response.status === 500 || erroServico.response.status === 400) {
        let msgErro = '';
        let msgDescricao = '';
        if (erroServico.response.data.erros) {
          if (erroServico.response.data.erros.length > 0) {
            const colecaoErro = erroServico.response.data.erros;
            colecaoErro.forEach((erro) => {
              if (erro.mensagem) {
                msgErro = erro.mensagem;
              }
            });
          }
          msgDescricao += ` ${msgErro} `;
        }
        erroServico.response.data = {};
        erroServico.response.data.mensagem = 'Houve um erro na tentativa de fazer a carga do documento.';
        if (tamanhoArquivo > tamanhoMaximoArquivoUpload) {
          erroServico.response.data.descricao = 'Certifique-se de que o documento possui tamanho inferior a 3 mb.';
        } else {
          erroServico.response.data.descricao = msgDescricao;
        }
      }
    }

    handleErrorMessages(erroServico || error, failCallback);
  }).then(() => {
    store.dispatch(actions.showLoading(false));
  });
};

export const doMultipartFormPost = (url, body, successCallback, failCallback) => {
  const config = {
    'Content-Type': 'multipart/form-data',
    Authorization: auth.getAuthorizationHeader(),
  };
  const formData = new FormData();
  const keys = Object.keys(body);
  keys.forEach((key) => {
    formData.set(key, body[key]);
  });
  doPost(url, formData, successCallback, failCallback, config);
};

// apagar
export const doMultipartFormPostTratamento = (url, body, successCallback, failCallback) => {
  const config = {
    'Content-Type': 'multipart/form-data',
    Authorization: auth.getAuthorizationHeader(),
  };
  doPost(url, body, successCallback, failCallback, config);
};

export const doMultipartFormPostMotivos = (url, body, successCallback, failCallback) => {
  const config = {
    'Content-Type': 'multipart/form-data',
    Authorization: auth.getAuthorizationHeader(),
  };
  doPost(url, body, successCallback, failCallback, config);
};

export const doMultipartFormPostExigencias = (url, body, successCallback, failCallback) => {
  const config = {
    'Content-Type': 'multipart/form-data',
    Authorization: auth.getAuthorizationHeader(),
  };
  const formData = new FormData();
  const keys = Object.keys(body);
  const tamanhoArquivo = body.documento.size;
  keys.forEach((key) => {
    formData.set(key, body[key]);
  });
  doPostExigencias(url, formData, successCallback, failCallback, config, tamanhoArquivo);
};

export const doGet = (url, successCallback, failCallback, params) => {
  store.dispatch(actions.showLoading(true));
  const instance = axios.create({
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.getAuthorizationHeader(),
    },
    data: {},
  });
  instance.get(
    `${url}`,
    {
      params: getURLParams(params),
    },
  ).then((response) => {
    store.dispatch(actions.showLoading(false));
    successCallback(response);
  }).catch((error) => {
    store.dispatch(actions.showLoading(false));
    handleErrorMessages(error, failCallback);
  });
};

export async function doGetPaginado(url, successCallback, failCallback, params, maxResult) {
  store.dispatch(actions.showLoading(true));
  const instance = axios.create({
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.getAuthorizationHeader(),
    },
    data: {},
  });

  const responseFinal = { data: [] };
  const parametros = params;
  parametros.start = 1;
  parametros.maxResult = maxResult;
  let keep = true;

  try {
    while (keep) {
      // eslint-disable-next-line no-await-in-loop
      const response = await instance.get(
        `${url}`,
        {
          params: getURLParams(parametros),
        },
      );

      if (response.data.length < parametros.maxResult) {
        keep = false;
      }

      responseFinal.data = responseFinal.data.concat(response.data);
      parametros.start += parametros.maxResult;
    }

    store.dispatch(actions.showLoading(false));
    successCallback(responseFinal);
  } catch (e) {
    store.dispatch(actions.showLoading(false));
    handleErrorMessages(e, failCallback);
  }
}

export const doGetListaMotivosCessacaoAposentadoria =
(url, tipoBeneficio, successCallback, failCallback, params) => {
  store.dispatch(actions.showLoading(true));
  const instance = axios.create({
    baseURL: baseUrl,
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.getAuthorizationHeader(),
    },
    data: {},
  });
  instance.get(
    `${url}`,
    {
      params: getURLParams(params),
    },
  ).then((response) => {
    successCallback(response, tipoBeneficio);
  }).catch((error) => {
    handleErrorMessages(error, failCallback);
  }).then(() => {
    store.dispatch(actions.showLoading(false));
  });
};

export const doGetFile = (fileId, filename) => {
  axios.get(`${baseUrl}/documentos/${fileId}`, {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/pdf',
      Authorization: auth.getAuthorizationHeader(),
    },
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename}.pdf`);
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    handleErrorMessages(error);
  });
};

export const doGetFileMsgPagamento = (fileId, filename) => {
  axios.get(`${baseUrl}/documentos-mensagem/${fileId}`, {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/pdf',
      Authorization: auth.getAuthorizationHeader(),
    },
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename}.pdf`);
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    handleErrorMessages(error);
  });
};

export const doPostDocumentoComUrlDinamica = (caminho) => {
  axios.post(`${baseUrl}${caminho}`, null, {
    responseType: 'arraybuffer',
    headers: {
      Accept: ['application/pdf', 'application/json'],
      Authorization: auth.getAuthorizationHeader(),
    },
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'gru.pdf');
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    const responseDecodificado = JSON.parse(new TextDecoder().decode(error.response.data));
    error.response.data = responseDecodificado;
    handleErrorMessages(error);
  });
};

export const doGetDocumentoComUrlDinamica = (fileId, filename, caminho) => {
  axios.get(`${baseUrl}${caminho}${fileId}`, {
    responseType: 'arraybuffer',
    headers: {
      Accept: 'application/pdf',
      Authorization: auth.getAuthorizationHeader(),
    },
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${filename}.pdf`);
    document.body.appendChild(link);
    link.click();
  }).catch((error) => {
    handleErrorMessages(error);
  });
};

export const doPut = (url, body, successCallback, failCallback, mensagemErro, config) => {
  store.dispatch(actions.showLoading(true));
  let configComAuth = {};
  let headersOpcionais = {};
  if (config) {
    headersOpcionais = config;
  }
  configComAuth = {
    headers: {
      Authorization: auth.getAuthorizationHeader(),
      ...headersOpcionais,
    },
  };
  axios.put(
    `${baseUrl}/${url}`,
    body,
    configComAuth,
  ).then((response) => {
    successCallback(response);
  }).catch((error) => {
    handleErrorMessages(error, failCallback, mensagemErro);
  }).then(() => {
    store.dispatch(actions.showLoading(false));
  });
};

export const doDelete = (url, id, successCallback, failCallback, mensagemErro) => {
  store.dispatch(actions.showLoading(true));
  const config = {
    method: 'delete',
    url: `${baseUrl}/${url}/${id}`,
    headers: {
      Authorization: auth.getAuthorizationHeader(),
      'Content-Type': 'application/json',
    },
  };
  axios(config)
    .then(() => {
      successCallback();
    })
    .catch((error) => {
      handleErrorMessages(error, failCallback, mensagemErro);
    }).then(() => {
      store.dispatch(actions.showLoading(false));
    });
};

export const doDeleteMotivo = (url, successCallback, failCallback, mensagemErro) => {
  store.dispatch(actions.showLoading(true));
  const config = {
    method: 'delete',
    url: `${baseUrl}/${url}`,
    headers: {
      Authorization: auth.getAuthorizationHeader(),
      'Content-Type': 'application/json',
    },
  };
  axios(config)
  .then(() => {
    successCallback();
  })
  .catch((error) => {
    handleErrorMessages(error, failCallback, mensagemErro);
  }).then(() => {
    store.dispatch(actions.showLoading(false));
  });
};

/**
 * Requisicoes de dados a serem guardados globalmente no estado do Redux
 */

const buscaDestinatariosSuccess = (response) => {
  // TipoRegimeProprio : Federal: 1, Municipal: 2, Estadual 3
  const listaParticipantesRenderizada = response.data.map(item => ({
    label: item.nome ? item.nome : 'RGPS',
    value: item.codigo,
    uf: item.uf,
    tipoRegimeProprio: item.tipoRegimeProprio,
    codigoOrgaoCentralizador: item.codigoOrgaoCentralizador,
    inOrgaoExtinto: item.inOrgaoExtinto,
    inOrgaoUniao: item.inOrgaoUniao,
    inOrgaoCentralizador: item.inOrgaoCentralizador,
  }));
  store.dispatch(actions.salvaDestinatarios(listaParticipantesRenderizada));
};

export const buscaDestinatarios = (callback) => {
  doGet('participantes-compensacao', buscaDestinatariosSuccess, callback);
};

const successTiposDocumentos = (response) => {
  const tiposDocumentos = response.data.map(item => (
    {
      value: item.codigo,
      label: item.descricao,
      acordoAplicavel: item.acordoAplicavel,
      regimeAplicavel: item.regimeAplicavel,
      abrangenciaAplicavel: item.abrangenciaAplicavel,
      categoria: item.categoria,
    }
  ));
  store.dispatch(actions.salvaTiposDocumentos(tiposDocumentos));
};

export const requestTiposDocumentos = (callback) => {
  doGet('tipos-documentos', successTiposDocumentos, callback);
};

const successExigencias = (response) => {
  const exigencias = response.data.map(item => (
    {
      value: item.tipo,
      label: item.acao,
      abrangenciaAplicavel: item.abrangenciaAplicavel,
      regimeAplicavel: item.regimeAplicavel,
      acordoAplicavel: item.acordoAplicavel,
    }
  ));
  store.dispatch(actions.salvaExigencias(exigencias));
};

export const requestExigencias = (callback) => {
  doGet('exigencias', successExigencias, callback);
};

const successExigenciasRPPS = (response) => {
  const exigencias = [];
  response.data.forEach((item) => {
    // if (item.regimeAplicavel === 2) {
    exigencias.push({
      value: item.tipo,
      label: item.acao,
      abrangenciaAplicavel: item.abrangenciaAplicavel,
      regimeAplicavel: item.regimeAplicavel,
      proprietario: item.proprietario,
      acordoAplicavel: item.acordoAplicavel,
    });
    // }
  });
  store.dispatch(actions.salvaExigencias(exigencias));
};

export const requestExigenciasRPPS = (callback) => {
  doGet('exigencias', successExigenciasRPPS, callback);
};

const successValoresMediosBeneficios = (response) => {
  const lista = [];
  let valor;
  if (response.data) {
    response.data.forEach((item) => {
      if (item.valorMedioBeneficio) {
        valor = item.valorMedioBeneficio.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
      } else {
        valor = 0;
        valor = valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
      }
      lista.push({
        competencia: item.dataCompetencia,
        valorMedioBeneficio: valor,
        exibirBotaoAlteracao: item.exibirBotaoAlteracao,
      });
    });
  }
  store.dispatch(actions.salvaValoresMediosBeneficios(lista));
};

export const requestValoresMediosBeneficios = (callback, paramCompetencia) => {
  doGet(
    'valores-medios-beneficios',
    successValoresMediosBeneficios,
    callback,
    {
      competencia: paramCompetencia,
    },
  );
};

const successMotivos = (response) => {
  const motivosIndeferimento = [];
  const motivosSuspensao = [];
  const motivosCessacao = [];
  const motivosNaoCumprimento = [];
  const motivosRejeicao = [];

  response.data.forEach((item) => {
    if (item.tipoMotivo === 1 ) {
      motivosIndeferimento.push({
        value: item.codigo,
        label: item.descricao,
        acordoAplicavel: item.acordoAplicavel,
        abrangenciaAplicavel: item.abrangenciaAplicavel,
        regimeAplicavel: item.regimeAplicavel,
      });
    }
    if (item.tipoMotivo === 2) {
      motivosSuspensao.push({
        value: item.codigo,
        label: item.descricao,
        acordoAplicavel: item.acordoAplicavel,
        abrangenciaAplicavel: item.abrangenciaAplicavel,
        regimeAplicavel: item.regimeAplicavel,
      });
    }
    if (item.tipoMotivo === 3) {
      motivosCessacao.push({
        value: item.codigo,
        label: item.descricao,
        acordoAplicavel: item.acordoAplicavel,
        abrangenciaAplicavel: item.abrangenciaAplicavel,
        regimeAplicavel: item.regimeAplicavel,
      });
    }
    if (item.tipoMotivo === 4) {
      motivosNaoCumprimento.push({
        value: item.codigo,
        label: item.descricao,
        acordoAplicavel: item.acordoAplicavel,
        abrangenciaAplicavel: item.abrangenciaAplicavel,
        regimeAplicavel: item.regimeAplicavel,
      });
    }
    if (item.tipoMotivo === 5) {
      motivosRejeicao.push({
        value: item.codigo,
        label: item.descricao,
        acordoAplicavel: item.acordoAplicavel,
        abrangenciaAplicavel: item.abrangenciaAplicavel,
        regimeAplicavel: item.regimeAplicavel,
      });
    }
  });

  store.dispatch(actions.salvaMotivosIndeferimento(motivosIndeferimento));
  store.dispatch(actions.salvaMotivosSuspensao(motivosSuspensao));
  store.dispatch(actions.salvaMotivosCessacao(motivosCessacao));
  store.dispatch(actions.salvaMotivosNaoCumprimento(motivosNaoCumprimento));
  store.dispatch(actions.salvaMotivosRejeicao(motivosRejeicao));
};

export const requestMotivos = (callback) => {
  doGet('motivos', successMotivos, callback);
};

const successMotivosCessacaoRequerimentoAposentadoria = (response, paramTipoBeneficio) => {
  const motivosCessacao = [];
  if (paramTipoBeneficio !== 3) {
    response.data.forEach((item) => {
      if (item.codigo !== 24) {
        motivosCessacao.push({
          value: item.codigo,
          label: item.descricao,
          acordoAplicavel: item.acordoAplicavel,
          regimeAplicavel: item.regimeAplicavel,
          abrangenciaAplicavel: item.abrangenciaAplicavel,
          tipoMotivo: item.tipoMotivo,
        });
      }
    });
  } else {
    response.data.forEach((item) => {
      motivosCessacao.push({
        value: item.codigo,
        label: item.descricao,
        acordoAplicavel: item.acordoAplicavel,
        regimeAplicavel: item.regimeAplicavel,
        abrangenciaAplicavel: item.abrangenciaAplicavel,
        tipoMotivo: item.tipoMotivo,
      });
    });
  }
  store.dispatch(actions.salvaMotivosCessacaoRequerimentoAposentadoria(motivosCessacao));
};

export const requestMotivosCessacaoRequerimentoAposentadoria = (
  callback,
  paramAplicacao,
  paramTipoMotivo,
  paramTipoBeneficio,
) => {
  doGetListaMotivosCessacaoAposentadoria(
    'motivos-cessacao',
    paramTipoBeneficio,
    successMotivosCessacaoRequerimentoAposentadoria,
    callback,
    {
      aplicacao: paramAplicacao,
      tipoMotivo: paramTipoMotivo,
    },
  );
};

const successMotivosCessacaoRequerimentoPensao = (response) => {
  const motivosCessacao = [];
  response.data.forEach((item) => {
    motivosCessacao.push({
      value: item.codigo,
      label: item.descricao,
      acordoAplicavel: item.acordoAplicavel,
      regimeAplicavel: item.regimeAplicavel,
      abrangenciaAplicavel: item.abrangenciaAplicavel,
      tipoMotivo: item.tipoMotivo,
    });
  });
  store.dispatch(actions.salvaMotivosCessacaoRequerimentoPensao(motivosCessacao));
};

export const requestMotivosCessacaoRequerimentoPensao = (
  callback, paramAplicacao,
  paramTipoMotivo,
) => {
  doGet(
    'motivos-cessacao',
    successMotivosCessacaoRequerimentoPensao,
    callback,
    {
      aplicacao: paramAplicacao,
      tipoMotivo: paramTipoMotivo,
    },
  );
};

const successMotivosCessacaoDependente = (response) => {
  const motivosCessacao = [];
  response.data.forEach((item) => {
    motivosCessacao.push({
      value: item.codigo,
      label: item.descricao,
      acordoAplicavel: item.acordoAplicavel,
      regimeAplicavel: item.regimeAplicavel,
      abrangenciaAplicavel: item.abrangenciaAplicavel,
      tipoMotivo: item.tipoMotivo,
    });
  });
  store.dispatch(actions.salvaMotivosCessacaoDependente(motivosCessacao));
};

export const requestMotivosCessacaoDependente = (
  callback, paramAplicacao,
  paramTipoMotivo,
) => {
  doGet(
    'motivos-cessacao',
    successMotivosCessacaoDependente,
    callback,
    {
      aplicacao: paramAplicacao,
      tipoMotivo: paramTipoMotivo,
    },
  );
};

const successPeriodosVigencia = (response) => {
  const periodosVigencia = response.data.map(item => (
    {
      cnpj: item.cnpj,
      // cnpj: item.cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5'),
      dataCriacaoRpps: item.dataCriacaoRpps,
      dataEncerramentoRpps: item.dataEncerramentoRpps,
      periodoFinalizado: item.periodoFinalizado,
    }
  ));
  store.dispatch(actions.salvaPeriodosVigencia(periodosVigencia));
};

export const requestPeriodosVigencia = (callback, codigo) => {
  doGet(`regimes-proprios/${codigo}`, successPeriodosVigencia, callback);
};
export const requestApagaPeriodosVigencia = () => {
  const colecaoVazia = [];
  store.dispatch(actions.apagaPeriodosVigencia(colecaoVazia));
};

export const solicitarCompetenciaAberta = () => {
  doGet(
    'fechamento-pagamentos/pagamento-aberto',
    response => store.dispatch(actions.salvaCompetenciaAberta(response.data)),
  );
};

export const solicitarEntesControlados = (id, success, error) => {
  doGet(`participantes-compensacao/listacentralizados/${id}`, success, error);
};

export const solicitarParticipante = (cnpj, success, error) => {
  doGet(`participantes-compensacao/${cnpj}`, success, error);
};

const successOrgaosCentralizados = (response) => {
  let orgaosCentralizados = [];
  if (response.data.centralizados && response.data.centralizados.length > 0) {
    orgaosCentralizados = response.data.centralizados.map(item => ({
      codigo: item.codigo,
      nome: item.nome,
      extinto: item.inOrgaoExtinto,
    }));
  }
  store.dispatch(actions.salvaOrgaosCentralizados(orgaosCentralizados));
};

export const requestOrgaosCentralizados = (callback, codigo) => {
  doGet(`participantes-compensacao/listacentralizados/${codigo}`, successOrgaosCentralizados, callback);
};

export const solicitarHabilitarQualificacao = () => {
  doGet('config/frontend', response => store.dispatch(actions.salvaConfiguracoesDeFrontend(response.data)));
};

// const successSolicitarHabilitarQualificacao = (response) => {
//   const retorno = {
//     exibirLinkPesquisaPendenciasAPagar: response.data.exibirLinkPesquisaPendenciasAPagar,
//     exibirLinkPesquisaPendenciasAReceber: response.data.exibirLinkPesquisaPendenciasAReceber,
//     nomeParticipantePendencia: response.data.nomeParticipantePendencia,
//   };
//   store.dispatch(actions.salvaConfiguracoesDeFrontend(retorno));
// };   

// export const solicitarPendenciasPorEnteLogado = () => {
//   doGet('config/frontend-pendencias-por-ente', successSolicitarPendenciasPorEnteLogado);
// };

// const successSolicitarPendenciasPorEnteLogado = (response) => {
//   const retorno = {
//     exibirLinkPesquisaPendenciasAPagar: response.data.exibirLinkPesquisaPendenciasAPagar,
//     exibirLinkPesquisaPendenciasAReceber: response.data.exibirLinkPesquisaPendenciasAReceber,
//     nomeParticipantePendencia: response.data.nomeParticipantePendencia,
//   };
//   store.dispatch(actions.salvaSolicitarPendenciasPorEnteLogado(retorno));
// };


const successAbrangenciasEntidadeParticipanteRPPS = (response) => {
  const abrangenciasEntidadeParticipanteRPPS = response.data.map(item => ({
    cnpj: item.cnpj,
    // cnpj: item.cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, '$1.$2.$3/$4-$5'),
    idParticipante: item.idParticipante,
    nomeOrgaoVinculado: item.nomeOrgaoVinculado,
    situacao: item.situacao,
  }));
  store.dispatch(actions.salvaAbrangenciasEntPartRPPS(abrangenciasEntidadeParticipanteRPPS));
};

export const requestAbrangenciasEntidadeParticipanteRPPS = (callback, codigo) => {
  doGet(
    `abrangencia-entidade-participante/${codigo}`,
    successAbrangenciasEntidadeParticipanteRPPS, callback,
  );
};

export const requestApagaAbrangenciasEntidadeParticipanteRPPS = () => {
  const colecaoVazia = [];
  store.dispatch(actions.apagaAbrangenciasEntidadeParticipanteRPPS(colecaoVazia));
};

export const salvarListaMensagens = (listaMensagemAlterada) => {
  store.dispatch(actions.salvarListaMensagens(listaMensagemAlterada));
};

export const requestSalvaFiltroBloqueio = (filtroBloqueio) => {
  store.dispatch(actions.salvaFiltroBloqueio(filtroBloqueio));
};

export const requestApagaFiltroBloqueio = () => {
  store.dispatch(actions.apagaFiltroBloqueio(null));
};

export const doPostComprovantes = (
  url, body, successCallback,
  failCallback, config, tamanhoArquivo,
) => {
  store.dispatch(actions.showLoading(true));
  let configComAuth = {};
  let headersOpcionais = {};
  if (config) {
    headersOpcionais = config;
  }
  configComAuth = {
    headers: {
      Authorization: auth.getAuthorizationHeader(),
      ...headersOpcionais,
    },
  };
  axios.post(
    `${baseUrl}/${url}`,
    body,
    configComAuth,
  ).then((response) => {
    successCallback(response);
  }).catch((error) => {
    const erroServico = error;
    if (url === 'documentos/comprovante' || url === 'documentos/comprovante/tratamento') {
      if (erroServico.response.status === 400 || erroServico.response.status === 500) {
        if (tamanhoArquivo > tamanhoMaximoArquivoUpload) {
          erroServico.response.data.descricao = 'Certifique-se de que o documento possui tamanho inferior a 3 mb.';
          erroServico.response.data.mensagem = 'Houve um erro na tentativa de fazer a carga do documento.';
        }
      }
    }

    handleErrorMessages(erroServico || error, failCallback);
  }).then(() => {
    store.dispatch(actions.showLoading(false));
  });
};

export const doMultipartFormPostComprovantes = (url, body, successCallback, failCallback) => {
  const config = {
    'Content-Type': 'multipart/form-data',
    Authorization: auth.getAuthorizationHeader(),
  };
  const formData = new FormData();
  const keys = Object.keys(body);
  const tamanhoArquivo = body.documento.size;
  keys.forEach((key) => {
    formData.set(key, body[key]);
  });
  doPostComprovantes(url, formData, successCallback, failCallback, config, tamanhoArquivo);
};

export const requestSalvaComplementoTitulo = (complementoTitulo) => {
  store.dispatch(actions.salvaComplementoTitulo(complementoTitulo));
};

export const requestApagaComplementoTitulo = () => {
  store.dispatch(actions.apagaComplementoTitulo(null));
};

const criarComplementoLabelPorAbrangencia = (label, abrangencia) => {
  let complemento = '';
  if (abrangencia !== null) {
    switch (abrangencia) {
    case 1:
      complemento = 'Aposentadoria';
      break;
    case 2:
      complemento = 'Pensão';
      break;
    case 3:
      complemento = 'Dependente';
      break;  
    default:
    break;
    }
  }
  return label+' - '+complemento;
}

const successMotivosRelatorio = (response) => {
  const motivosIndeferimento = [];
  const motivosSuspensao = [];
  const motivosCessacao = [];

  response.data.forEach((item) => {
    if (item.tipoMotivo === 1 ) {
      motivosIndeferimento.push({
        value: item.codigo,
        label: criarComplementoLabelPorAbrangencia(item.descricao, item.abrangenciaAplicavel),
      });
    }
    if (item.tipoMotivo === 2) {
      motivosSuspensao.push({
        value: item.codigo,
        label: criarComplementoLabelPorAbrangencia(item.descricao, item.abrangenciaAplicavel),
      });
    }
    if (item.tipoMotivo === 3) {
      motivosCessacao.push({
        value: item.codigo,
        label: criarComplementoLabelPorAbrangencia(item.descricao, item.abrangenciaAplicavel),
      });
    }    
  });

  store.dispatch(actions.salvaMotivosIndeferimentoRelatorio(motivosIndeferimento));
  store.dispatch(actions.salvaMotivosSuspensaoRelatorio(motivosSuspensao));
  store.dispatch(actions.salvaMotivosCessacaoRelatorio(motivosCessacao));
};

export const requestMotivosRelatorio = (callback) => {
  doGet('motivos', successMotivosRelatorio, callback);
};

const successExigenciasRelatorio = (response) => {
  const exigencias = response.data.map(item => (
    {
      value: item.tipo,
      label: criarComplementoLabelPorAbrangencia(item.acao, item.abrangenciaAplicavel),
    }
  ));
  store.dispatch(actions.salvaExigenciasRelatorio(exigencias));
};

export const requestExigenciasRelatorio = (callback) => {
  doGet('exigencias', successExigenciasRelatorio, callback);
};

const buscaEstadosSimulacaoCompensacaoSuccess = (response) => {
  const estadosSimulacaoCompensacao = response.data.map(item => (
    {
      value: item.estado,
      label: item.nome,
    }
  ));
  store.dispatch(actions.salvaEstadosSimulacaoCompensacaoSuccess(estadosSimulacaoCompensacao));
};

export const buscaEstadosSimulacaoCompensacao = (callback, codigo) => {
  doGet(`relatorios/simulacao-calculo/lista-estados-reqs-participante/${codigo}`, buscaEstadosSimulacaoCompensacaoSuccess, callback);
};


// WEBPACK FOOTER //
// ./src/utils/requests.js